import noop from 'lodash/noop';

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationsCenterService } from './notifications.service';

import { GREY_5 } from '@app/lib/colors';
import { INotification } from './notification.interface';
import { customLocaleKey } from './notification-utils';

@Component({
  selector: 'notification-item',
  templateUrl: 'notification-item.component.html',
  styleUrls: ['notification-item.component.scss'],
})
export class NotificationItemComponent {
  @Input() public notification: INotification;
  @Input() public loading: boolean;
  @Input() public hidePriority: boolean;
  @Output() public notificationClicked: EventEmitter<number> = new EventEmitter();
  public GREY_5: string = GREY_5;

  constructor(
    private notificationsService: NotificationsCenterService,
    private router: Router,
  ) {}

  public formatCreatedAt(): string {
    this.notification.createdAt?.locale(customLocaleKey);
    return this.notification.createdAt?.fromNow();
  }

  public onClick(): void {
    this.handleNotificationAction();
    this.markAsRead();
    this.notificationClicked.emit(this.notification.id);
  }

  private handleNotificationAction(): void {
    if (this.notification.action?.isQueryParam) {
      this.router.navigate([], {
        queryParams: this.notification.action.queryParams,
        queryParamsHandling: 'merge',
      });

    } else if (this.notification.action.redirectUri) {
      const path: string = this.notification.action.redirectUri.substring(this.notification.action.redirectUri.indexOf('#') + 1);
      this.router.navigateByUrl(path);
    }
  }

  private markAsRead(): void {
    if (!this.notification.read) this.notificationsService.markNotificationsRead([this.notification.id]).subscribe(noop);
    this.notification.read = true;
  }
}
